import React from "react";

import Avatar from "../../../components/avatar/Avatar";

const ReviewCard = ({
  currentPath = "",
  isViewTestimonial = false,
  isTopMenu = false,
  avatarSrc = "/images/eligibility/avatar.png",
  review
}) => {
  return (
    <div className="d-flex flex-row">
      {isViewTestimonial ? (
        <div className="d-block w-50">
          <Avatar src={avatarSrc} />
        </div>
      ) : (
        <div className="d-none d-md-block w-50">
          <Avatar src={avatarSrc} />
        </div>
      )}
      <div className="d-flex flex-column">
        <p
          className={`mb-3 ${
            currentPath === "eligibility-success" ||
            (currentPath === "eligibility-error" && !isTopMenu) ||
            (currentPath === "eligibility-age-error" && !isTopMenu)
              ? "text-white"
              : "text-black"
          }`}
        >
          {review?.review}{" "}
          <a
            href="https://www.trustpilot.com/review/treat-it.clinic?stars=5"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 fw-semibold text-decoration-none"
          >
            Read more
          </a>
        </p>
        <p
          className={`${!isViewTestimonial && "d-none d-md-block"
            } flow-gap mb-0 ${currentPath === "eligibility-success" ||
              (currentPath === "eligibility-error" && !isTopMenu) ||
              (currentPath === "eligibility-age-error" && !isTopMenu)
              ? "text-white"
              : "text-dark-6"
            }`}
        >
          {review?.nameDate}
        </p>
        {!isViewTestimonial && (
          <div className="d-flex flex-row d-md-none align-items-center">
            <div>
              <Avatar src={avatarSrc} />
            </div>
            <p className="flow-gap mb-0">{review?.nameDate}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewCard;
